var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-3"},_vm._l((_vm.links),function(link){return _c('router-link',{key:link.hash,staticClass:"mx-3",attrs:{"to":{ name: 'dashboard', hash: link.hash }}},[_vm._v("\n    "+_vm._s(link.label)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }